<template>
  <DefaultTransitionModal
    ref="mc-modal-canceled"
    :textSecondaryBtn="$t('global.back')"
    :textPrimaryBtn="$t('fleetTaskInstant.confirmModal.transitionToCanceled.confirmBtn')"
    :hideStatusPreview="true"
    :entityData="entityData"
    :newStatusTransition="newStatusTransition"
    @transition="triggerSubmit"
  >
    <template #title>
      {{ $t('fleetTaskInstant.confirmModal.transitionToCanceled.title') }}
    </template>
    <template #confirmationText>
      <div>
        <McAlert withIcon variant="warning" class="mb-2">
          <template #label>
            <span v-html="$t('fleetTaskInstant.confirmModal.transitionToCanceled.alertText')" />
          </template>
        </McAlert>

        <p
          v-if="selectedItems.length > 1"
          v-html="
            $t('fleetTaskInstant.confirmModal.transitionToCanceled.content.itemMoreThanOne', {
              total: selectedItems.length,
            })
          "
        />
        <p
          v-else
          v-html="
            $t('fleetTaskInstant.confirmModal.transitionToCanceled.content.one', {
              foNumber: selectedItems[0]?.number,
            })
          "
        />

        <FormulateForm
          v-model="formValues"
          name="reason-form"
          @submit="handleSubmit"
          @failed-validation="handleFailedValidation"
        >
          <FormulateInput
            class="p-0"
            type="text"
            name="reason"
            validation="required"
            :label="$t('fleetTaskInstant.field.reasonForCancellation')"
            :placeholder="$t('fleetTaskInstant.placeholder.reasonForCancellation')"
            :help="true"
          />
        </FormulateForm>
      </div>
    </template>
  </DefaultTransitionModal>
</template>

<script>
import DefaultTransitionModal from '@/components/McTransitionStatus/DefaultTransitionModal.vue'
import McAlert from '@/components/McAlert'

export default {
  components: {
    DefaultTransitionModal,
    McAlert,
  },
  props: {
    entityData: {},
    newStatusTransition: {},
    selectedItems: {},
  },
  emits: ['transition'],
  data() {
    return {
      formValues: {},
    }
  },
  methods: {
    triggerSubmit() {
      this.$formulate.submit('reason-form')
    },
    handleSubmit(data) {
      this.$emit('transition', {
        transition: this.newStatusTransition,
        additionalPayload: {
          fields: {
            reason: data['reason'],
          },
        },
      })
    },
    handleFailedValidation(_field) {
      this.$mcToast.error(this.$t('global.inputFormatError'))
    },
    // NOTE:
    // This function will be called from parents,
    // Ideally we capitalized the first letter of the function name
    // but the name are kept as 'show' and 'hide' to match bootstrap's convention
    // of modal 'show' and 'hide' function
    show() {
      this.$refs['mc-modal-canceled'].show()
    },
    hide() {
      this.$refs['mc-modal-canceled'].hide()
    },
  },
}
</script>
